import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TRIGGERS_WIZARD_LINK: `${cleanedFilename(__filename)}-triggers-wizard-link`,
};
